import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getMe } from '../services/api';

const ADMIN_ROLES = ['super_admin', 'admin', 'moderator', 'custom'];

export default function ProtectedRoute({ children, requiredRole }) {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) return;

    const checkAuth = async () => {
      try {
        const response = await getMe();
        setUser(response.data);
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [location.state]);

  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0F2A44]"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // For super_admin requiredRole, allow all admin-tier roles
  if (requiredRole === 'super_admin' && !ADMIN_ROLES.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  // For other requiredRoles, exact match
  if (requiredRole && requiredRole !== 'super_admin' && user?.role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  return children;
}